import { render, staticRenderFns } from "./Composicao.vue?vue&type=template&id=1bc33b1c"
import script from "./Composicao.vue?vue&type=script&lang=js"
export * from "./Composicao.vue?vue&type=script&lang=js"
import style0 from "./Composicao.vue?vue&type=style&index=0&id=1bc33b1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports